<template>
  <div>
    <b-navbar sticky="true" type="light" variant="light">
		<div class="container">
			<b-navbar-brand to="/minecraft-feedback">我的世界玩家群</b-navbar-brand>
			<b-navbar-nav class="ml-auto" small="true" >
				<!-- <b-nav-item to="#">概览</b-nav-item>
      			<b-nav-item to="#">如何使用</b-nav-item> -->
				<b-button rel="noopener" target="_blank" pill size="sm" variant="outline-primary" @click="leaveFor" href="https://jq.qq.com/?_wv=1027&k=5QXnAqa" >现在加入</b-button>
			</b-navbar-nav>
		</div>
    </b-navbar>

			<div class="QQ_container" style="text-align: center;" >
				<div>
          <img class="avatar" src="@/assets/Avatar.jpg" >
					<!-- <h1>初次见面，请多指教～</h1> -->
					<h2>在下雪谋，专注于皮肤制作 (๑>◡<๑)</h2>
          <p>如果你有什么好的想法、意见或建议，欢迎加群讨论玩耍。</p>
          <b-button target="_blank" pill size="lg" variant="primary" href="https://jq.qq.com/?_wv=1027&k=5QXnAqa" ><img class="QQ_icon" src="@/assets/QQ_white_icon.png" >加入群聊</b-button>
          <h4>我的世界 QQ 交流群：967757787</h4>
				</div>
			</div>

  </div>
</template>

<style lang="stylus" scoped>
	@import '~@/components/OverviewCard.styl'
  .avatar {
    width 120px
    border-radius 50%
    padding-bottom: 20px
  }
  .QQ_icon {
    width 30px
    margin-top -5px
    margin-left -6px
    margin-right 4px
  }
  .QQ_container {
    padding: 40px;
    position: static;
    width: 100%;
    height: 100%;
    overflow: hidden;
    display: flex; // div 居中
    align-items: center; // div 居中
    justify-content: center; // div 居中
  }
  h1 {
    font-size 20px
    color #999999
    line-height 2
  }
  h2 {
    font-size 20px
    color #999999
    line-height 2.5
  }
  p {
    font-size 20px
    color #000000
    line-height 2
  }
  h4 {
    font-size 14px
    color #9B9B9B
    line-height 3
    font-weight: 200
  }
</style>

<script>
import PartnerAuthor from '@/components/PartnerAuthor'
export default {
    methods: {
        leaveFor() {
            this.$ga.event('minecraft', 'minecraft', 'minecraft-feedback', 1)
            },
	},
  name: 'about',
    components: {
        PartnerAuthor
  }
}
</script>